import { DefaultLoaderProps } from './types';

/**
 * Processes an image source URL, optionally adding a suffix before the extension.
 */

const domainRegex = /^(?:https?:\/\/)?(?:[^@\n]+@)?(?:www\.)?([^:/\n?]+)/;

function defaultLoader({ src, suffix, proxySuffix }: DefaultLoaderProps) {
  // If src is empty or invalid, just return it as is
  const domainOfImage = new RegExp(domainRegex).exec(src)?.[0] ?? null;

  //for local development
  // const maskedSrc = src;

  const replacement = domainOfImage?.includes('sandbox') ? '/images' : `/${proxySuffix}`;

  //*To load images locally use the below line
  // const maskedSrc = src.replace(domainOfImage ?? '', `https://dev-us.googlephotos.fujifilm.com${replacement}`);

  const maskedSrc = src.replace(domainOfImage ?? '', replacement);
  if (!maskedSrc || typeof maskedSrc !== 'string') {
    return maskedSrc;
  }

  // If no suffix needed, return src as is
  if (!suffix) {
    return maskedSrc;
  }

  // If src doesn't contain a dot (for file extension), return it as is
  const lastDotIndex = maskedSrc.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return maskedSrc;
  }

  // Add suffix before extension
  return `${maskedSrc.substring(0, lastDotIndex)}.${maskedSrc.substring(lastDotIndex + 1)}&${suffix}`;
}

export const netlifyLoader = ({ src, width, quality }: { src: string; width: number; quality?: number }) => {
  return `${src}&w=${String(width)}&q=${String(quality || 75)}`;
};

export default defaultLoader;
